import { buildHubAsync } from "./signalR.js";

function logConnectionEvents(connection, eventName) {
	connection.on(eventName, () => console.log(`SignalR Event: ${eventName}`));
}
// Public
export async function buildConferenceHubAsync(hubConfig, notarizationId) {
	const connection = await buildHubAsync(window.Notary.Config.Hubs.Conference, hubConfig, `${notarizationId}`);

	if (hubConfig.debugLog) {
		logConnectionEvents(connection, `NotaryPing`);
		logConnectionEvents(connection, `LawDepotPingBack`);
		logConnectionEvents(connection, `StartCall`);
		logConnectionEvents(connection, `SessionId`);
		logConnectionEvents(connection, `DocumentStatusUpdated`);
		logConnectionEvents(connection, `EndCall`);
		logConnectionEvents(connection, `ReloadDocument`);
		logConnectionEvents(connection, `ClientDisconnected`);
		logConnectionEvents(connection, `NotaryDisconnected`);		
	}

	if (hubConfig.onNotaryPing) {
		connection.on(`NotaryPing`, hubConfig.onNotaryPing);
	}
	if (hubConfig.onLawDepotPingBack) {
		connection.on(`LawDepotPingBack`, hubConfig.onLawDepotPingBack);
	}
	if (hubConfig.onStartCall) {
		connection.on(`StartCall`, hubConfig.onStartCall);
	}
	if (hubConfig.onSessionId) {
		connection.on(`SessionId`, hubConfig.onSessionId);
	}
	if (hubConfig.onDocumentStatusUpdated) {
		connection.on(`DocumentStatusUpdated`, hubConfig.onDocumentStatusUpdated);
	}
	if (hubConfig.onEndCall) {
		connection.on(`EndCall`, hubConfig.onEndCall);
	}
	if (hubConfig.onReloadDocument) {
		connection.on(`ReloadDocument`, hubConfig.onReloadDocument);
	}
	if (hubConfig.onClientDisconnected) {
		connection.on(`ClientDisconnected`, hubConfig.onClientDisconnected);
	}
	if (hubConfig.onNotaryDisconnected) {
		connection.on(`NotaryDisconnected`, hubConfig.onNotaryDisconnected);
	}

	return connection;
}
